export default __webpack_public_path__ + "static/avator-8e997725aa6dba1f466150c91cdb679f.jpg";